export const getMMAEditorStyles = () => ({
  '@global': {
    '.top-grid-form .ad-editor__container .crud-audience-ad .react-image-experience .crud-audience-ad-react.crud-multimedia-ad-react': {
      '& .ad-edit-and-preview-container': {
        position: 'relative',
        '& .ad-customizer-container': {
          '& .picker-list, > .dropdown-menu.adCustomizersEditor': {
            marginTop: 0,
            marginLeft: 0,
          },
        },
        '& .image-experience-content': {
          minWidth: 'unset',
          '& .image-list-view-content .image-list .image-list-content': {
            width: '100%',
            border: 'none',
            margin: 0,
            padding: 0,
            '& .image-list-item.image-list-add-placeholder': {
              borderStyle: 'dashed',
              borderColor: '#c8c6c4',
              borderRadius: 6,
              borderWidth: 1,
              marginTop: 8,
            },
            '& .image-list-choice-group': {
              '& .ms-ChoiceFieldGroup-flexContainer': {
                flexWrap: 'wrap',
                width: 'unset',
                '& .ms-ChoiceField': {
                  marginBottom: 4,
                  marginRight: 8,
                  '& ~ .ms-ChoiceField': {
                    marginLeft: 0,
                  },
                },
              },
            },
          },
        },
      },
      '& .actionextension-search-dropdown-container .dropdown-search-selector__dropdown': {
        marginLeft: 0,
        '& .dropdown-toggle .text-left': {
          padding: '4px 0 0 8px',
        },
      },
    },
    'div .adEditor-container .ad-editor-form__container .crud-audience-ad .react-image-experience .crud-audience-ad-react.crud-multimedia-ad-react': {
      '& .ad-edit-and-preview-container': {
        position: 'relative',
        '& .ad-customizer-container': {
          '& .picker-list, > .dropdown-menu.adCustomizersEditor': {
            marginTop: 0,
            marginLeft: 0,
          },
        },
        '& .image-experience-content': {
          minWidth: 'unset',
          '& .image-list-view-content .image-list .image-list-content': {
            '& .image-list-item.image-list-add-placeholder': {
              marginTop: 8,
            },
            '& .image-list-choice-group .ms-ChoiceFieldGroup-flexContainer': {
              flexFlow: 'row',
              display: 'flex',
              flexWrap: 'wrap',
              width: 'unset',
              '& .ms-ChoiceField': {
                marginBottom: 4,
                marginRight: 8,
                '& ~ .ms-ChoiceField': {
                  marginLeft: 0,
                },
              },
            },
          },
        },
      },
      '& .actionextension-search-dropdown-container .dropdown-search-selector__dropdown': {
        marginLeft: 0,
        '& .dropdown-toggle .text-left': {
          padding: '4px 0 0 8px',
        },
      },
    },
    '.ads-page': {
      paddingTop: 24,
      '& .top-grid-form .panel': {
        marginTop: 0,
      },
    },
  },
  adEditorShell: {
    width: '100%',
  },
  mmaAdImagePreviewCarousel: {
    position: 'sticky',
    width: '100%',
    minWidth: 669,
    top: '0px',
    '& .new-preview-carousel-container-adprelib': {
      '& .new-carousel-navigation-mma-adprelib': {
        '& .carousel-indicators': {
          left: 20,
          margin: '20px 24px',
          position: 'absolute',
          width: 'auto',
        },
        '& .carousel-control.left': {
          left: 0,
          bottom: -7,
          position: 'absolute',
          marginLeft: 15,
          marginRight: 76,
          height: 32,
          marginTop: 20,
          marginBottom: 20,
          top: 'auto',
          right: 0,
        },
        '& .carousel-control.right': {
          left: 0,
          bottom: -7,
          position: 'absolute',
          marginLeft: 135,
          marginRight: 76,
          height: 32,
          marginTop: 20,
          marginBottom: 20,
          top: 'auto',
          right: 0,
        },
      },
    },
  },
  rightStyles: {
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
  },
  container: {
    display: 'flex',
    width: '100%',
    gap: '32px',
    '& .text-input-container': {
      width: '100% !important',
    },
    '& .title-item': {
      width: 'auto',
      maxWidth: '100%',
    },
  },
  leftStyles: {
    width: '40%',
    maxWidth: 600,
    minWidth: 482,
    '& .text-assets-collection-container': {
      width: 'unset',
      '& label.control-label': {
        textAlign: 'left',
      },
    },
    '& .business-name-container': {
      width: 'unset',
    },
  },
  headerStackStyles: {
    width: 'unset',
    '& .server-errors': {
      marginBottom: 15,
      '& .error a': {
        color: '#A80000',
      },
    },
  },
  imageExperienceStyle: {
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
    '& .image-list-choice-group .ms-ChoiceFieldGroup-flexContainer': {
      width: 'unset !important',
    },
    '& .image-suggestion-carousel-root .panel-heading .see-all-link': {
      fontWeight: 'normal',
    },
  },
  textAssetStyle: {
    '& .text-assets-collection-container': {
      width: '100%',
    },
  },
  businessNameStyle: {
    '& .business-name-container': {
      width: '100%',
    },
  },
});

